<template>
  <div>

    <div
      v-if="isLoaded"
      class="text-center py-10 flex items-center justify-center"
    >
      <XSpinner class="text-4xl text-info-50" />
    </div>

    <div v-else>
      <div
        class="my-4 p-2 bg-grey-40 text-center rounded"
      >
        <span
          class="text-white"
          style="font-size: 18px;"
        >
          Precio de la entrada: <span class="font-bold">{{ currencyFormatEUR(Number(priceTicket)) }}</span>
        </span>
      </div>
    </div>

    <XField
      :errors="error === null ? null : [error]"
      :errorStyle="formFieldsErrorStyle"
    >
      <div
        id="payment-element"
      />
    </XField>

    <div
      class="flex mt-5">
      <div class="w-1/2" />
      <div
        class="w-1/2 text-right">
        <img src="@/platform/assets/images/powered-by-stripe.png">
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import gql from 'graphql-tag'

export default {
  props: {
    label: {
      type: String
    },
    labelStyle: {
      type: Object
    },
    errorStyle: {
      type: Object
    },
    stripeKey: {
      type: String,
      required: true
    },
    buyerFullName: {
      type: String
    },
    buyerEmail: {
      type: String
    },
    priceTicket: {
      type: Number,
      required: true
    },
    eventId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      stripe: null,
      stripeCard: null,
      stripeElements: null,
      isCardCompleted: false,
      isLoaded: true,
      paymentIntentSecret: '',
      paymentIntentId: '',
      error: null
    }
  },

  computed: {
    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    },

    formFieldsErrorStyle () {
      return {
        position: 'relative',
        top: '-3px',
        backgroundColor: this.errorStyle.backgroundColor,
        color: this.errorStyle.color,
        margin: '0',
        padding: '0.5em',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
        fontWeight: '500'
      }
    }
  },

  created () {
    this.stripe = window.Stripe(this.stripeKey)
  },

  mounted () {
    this.getPaymentIntent()
  },

  watch: {
    priceTicket: function (newPrice, oldPrice) {
      this.isLoaded = true
      this.isCardCompleted = false
      this.stripeCard.unmount()
      this.getPaymentIntent()
      return newPrice
    },
    buyerEmail: function (newVal, oldVal) {
      return newVal
    }
  },

  methods: {
    mountInput () {
      // const appearance = {
      //   theme: 'night',
      //   labels: 'floating'
      // }
      this.stripeElements = this.stripe.elements()
      this.stripeCard = this.stripeElements.create('card', {
        classes: {
          base: DEFAULT_INPUT_CLASSES
        }
      })

      this.stripeCard.mount('#payment-element')
      this.stripeCard.addEventListener('change', ({ complete, error }) => {
        this.isCardCompleted = complete
        this.error = error ? error.message : null
      })

      this.stripeCard.addEventListener('ready', (event) => {
        this.isLoaded = false
      })
    },

    async getPaymentIntent () {
      this.$apollo
        .query({
          query: gql`query Event ($eventId: Uuid!, $priceTicket: String!) {
            event (eventId: $eventId) {
              ticketPaymentIntent (priceTicket: $priceTicket) {
                stripePaymentIntentSecret
                stripePaymentIntentId
              }
            }
          }`,
          fetchPolicy: 'network-only',
          variables: {
            eventId: this.eventId,
            priceTicket: this.priceTicket
          }
        })
        .then(result => {
          this.paymentIntentSecret = result.data.event.ticketPaymentIntent.stripePaymentIntentSecret
          this.paymentIntentId = result.data.event.ticketPaymentIntent.stripePaymentIntentId
          this.mountInput(this.paymentIntentSecret)
        })
    },

    async pay () {
      this.error = null
      const buyerFullname = this.buyerFullName
      const buyerEmail = this.buyerEmail

      const paymentStatus = await this.stripe.retrievePaymentIntent(this.paymentIntentSecret)
      if (paymentStatus.paymentIntent !== undefined && paymentStatus.paymentIntent.status === 'succeeded') {
        return true
      }

      const result = await this.stripe.confirmCardPayment(
        this.paymentIntentSecret,
        {
          payment_method: {
            card: this.stripeCard,
            billing_details: {
              name: buyerFullname,
              email: buyerEmail
            }
          },
          receipt_email: buyerEmail
        }
      )

      if (result.paymentIntent !== undefined && result.paymentIntent.status === 'succeeded') {
        return true
      }

      const error = result.error
      if (error) {
        this.error = error.message
      }

      this.error = 'No se ha podido completar el pago.'
      return false
    },

    currencyFormatEUR (num) {
      return (
        num
          .toFixed(2) // always two decimal digits
          .replace('.', ',') // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
      ) // use . as a separator
    }
  }
}

const DEFAULT_INPUT_CLASSES = [
  'w-full',
  'bg-white',
  'rounded',
  'border',
  'border-solid',
  'border-grey-80',
  'px-4',
  'py-4',
  'mb-4',
  'outline-none',
  'focus:shadow-outline-info',
  'focus:border-info-50',
  'text-grey-40',
  'appearance-none'
].join(' ')
</script>
